/**
 * Admin-side reader/writer for MAPS runtime settings (Configuration tab).
 *
 * Backed by the existing FeedbackPlatform.SystemSetting / "System Settings"
 * MJ entity with maps.* keys (see apps/MJAPI/src/resolvers/maps/settings.ts).
 * Both calls require an admin token; the resolver enforces that.
 */
import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { firstValueFrom } from 'rxjs';
import { MAPS_SETTINGS, MAPS_SETTINGS_UPDATE } from './maps-graphql/queries';
import type { MapsSettings, MapsSettingsInput } from '../models/maps.types';

@Injectable({ providedIn: 'root' })
export class MapsSettingsService {
    constructor(private readonly apollo: Apollo) {}

    async Load(): Promise<MapsSettings> {
        const result = await firstValueFrom(
            this.apollo.query<{ mapsSettings: MapsSettings }>({
                query: MAPS_SETTINGS,
                fetchPolicy: 'network-only',
            })
        );
        if (!result.data?.mapsSettings) {
            throw new Error('mapsSettings returned empty payload');
        }
        return result.data.mapsSettings;
    }

    async Save(input: MapsSettingsInput): Promise<MapsSettings> {
        const result = await firstValueFrom(
            this.apollo.mutate<{ mapsSettingsUpdate: MapsSettings }>({
                mutation: MAPS_SETTINGS_UPDATE,
                variables: { input },
            })
        );
        if (!result.data?.mapsSettingsUpdate) {
            throw new Error('mapsSettingsUpdate returned empty payload');
        }
        return result.data.mapsSettingsUpdate;
    }
}
